import { BoxBody } from "pages/home/components/CommunicationSection/CommunicationRateSection/components/BoxBody";
import { BoxTitle } from "pages/home/components/CommunicationSection/CommunicationRateSection/components/BoxTitle";
import { Container2, Row4 } from "pages/home/components/Layout";

export const CommunicationRate = ({
  filteredSuggests,
  filteredInquiries,
  suggestPer1,
  suggestPer,
  inquiriesPer1,
  inquiriesPer,
}) => {
  return (
    <Container2
      $width={250}
      $height={315}
      $top={14}
      $right={26}
      $bottom={35}
      style={{ border: "1px solid #E8E8E8" }}
    >
      <Row4>
        <BoxTitle
          filteredSuggests={filteredSuggests}
          filteredInquiries={filteredInquiries}
        />
        <BoxBody
          suggestPer={suggestPer}
          suggestPer1={suggestPer1}
          inquiriesPer={inquiriesPer}
          inquiriesPer1={inquiriesPer1}
        />
      </Row4>
    </Container2>
  );
};
